//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbHeaderMessageBarButton from '@/elements/header/message-bar-button/message-bar-button.vue'
import RbDynamicSwiperSlide from '@/elements/smart-container/dynamic-swiper-slide'
import { RB_APP__MAIN, WCS_CONTAINER, WCS_STATIC_PAGE } from '@/scripts/constants/css-classes'
import { HEADER, MOBILE, TABLET } from '@/scripts/constants/media-query'
import WCAG from '@/scripts/libs/wcag/wcag'

export default {
  name: 'rb-header-message-bar',
  components: {
    RbHeaderMessageBarButton,
    RbDynamicSwiperSlide,
  },
  props: {
    isOmnichannelOpen: {
      type: Boolean,
      default: false,
    },
    isNoEcommerce: {
      type: Boolean,
      default: false,
    },
    isButtonVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiperConfig: {
        autoplay: { delay: 7000, disableOnInteraction: false },
        loop: true,
        effect: 'fade',
        touchStartPreventDefault: false,
      },
      skipToMainContentIsVisible: false,
    }
  },
  computed: {
    swiperSlides() {
      return this.$slots.content?.filter((slot) => !!slot.tag)
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET || this.$mq === HEADER
    },
  },
  methods: {
    emitButtonClick() {
      this.$emit('buttonClicked')
    },
    showSkipToMainContentButton() {
      this.skipToMainContentIsVisible = true
    },
    hideSkipToMainContentButton() {
      this.skipToMainContentIsVisible = false
    },
    navigateToAndFocus(element) {
      WCAG.navigateToAndFocus({ element, addNavigation: true })
    },
    skipToMainContent() {
      this.$emit('skipToMainContentClicked')
      const appMain = document.getElementsByClassName(RB_APP__MAIN)[0]
      if (appMain) {
        this.navigateToAndFocus(appMain)
        return
      }

      const wcsContainerStatic = document.getElementsByClassName(WCS_STATIC_PAGE)[0]
      if (wcsContainerStatic) {
        this.navigateToAndFocus(wcsContainerStatic)
        return
      }

      const wcsMain = document.getElementById('maincontent')
      if (wcsMain) {
        this.navigateToAndFocus(wcsMain)
        return
      }

      const wcsContainer = document.getElementsByClassName(WCS_CONTAINER)[0]
      if (wcsContainer) {
        this.navigateToAndFocus(wcsContainer)
      }
    },
    onKeyPress(e) {
      if (WCAG.isEnterPressed(e)) {
        const currentSlideIndex = this.$refs.swiper?.getSlideIndex()
        const currentSlide = this.swiperSlides[currentSlideIndex]
        const currentSlideURL = currentSlide?.componentOptions?.propsData?.url
        if (currentSlideURL) {
          window.location.href = currentSlideURL
        }
      }
    },
  },
}
